import { Button } from '@/components/ui/button'
import { IconHomeSearch, IconList, IconListLetters, IconMail } from '@tabler/icons-react'
import React from 'react'
import { Link } from 'react-router-dom'

export default function CtaSuchprofil() {
  return (
    <div>
        <div className="container md:h-[25rem] items-center flex flex-col-reverse md:flex-row justify-between mx-auto md:px-4 ">
            <div className='md:w-1/2 px-4 md:px-0 xl:px-4 mt-5'>
                
                <h2 className="font-bold text-xl pb-4 text-prime-950 md:text-2xl lg:text-3xl "><IconMail className='md:size-10 mb-4 size-7 '/> Neue Angebote direkt in Ihr Postfach</h2>
                <p className="text-lg text-gray-700">Viele unserer  Immobilien gehen nur an vorgemerkte Suchkunden. Erstellen Sie jetzt Ihr Suchprofil und sichern Sie sich exklusive Angebote!</p>
               <Link to={'/immobilien/suchprofil-anlegen'}><Button className='my-5 h-[3.5rem] md:mt-8 bg-prime-600 hover:bg-prime-800' href='/suchprofil' >Suchprofil erstellen <IconHomeSearch/></Button></Link>
            </div>
            <div className=' md:w-1/2 flex justify-center'>
                <img className='object-cover  md:max-h-[30rem] max-h-[22rem] md:h-full' src="/Fotos/landingpage-suchprofil-jakobs.webp" alt="Ein Bild von einem Gerätmockup mit einem Klingel und Glocken Icon" />
            </div>
        </div>
    </div>
  )
}
